<template>
  <v-dialog
    :value="edited.record && edited.field === 'comment'"
    max-width="600px"
    @click:outside="saveEdited()"
    @keydown.esc="saveEdited()"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Edit comment</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="edited.value"
                label="Comment"
                clearable
                clear-icon="mdi-close-circle-outline"
                autofocus
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          text
          @click.stop="resetEdited()"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          text
          dark
          @click.stop="saveEdited()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
	name: 'CommentEditor',
	data: () => ({}),
	computed: {
		...mapState('journal', {
			edited: state => state.edited,
		}),
	},
	methods: {
		...mapActions('journal', ['saveEdited', 'resetEdited']),
	},
}
</script>

<style lang="scss">
</style>
